import { Clock } from 'lucide-react'

import { Pill, Tooltip } from '~/components/component-library'
import { Timestamp } from '~/components/component-library/Timestamp'

export const CliffPill = ({ cliffTime }: { cliffTime?: number }) => (
  <Tooltip
    content={
      cliffTime ? (
        <Timestamp timestamp={cliffTime * 1000} type="absolute" />
      ) : (
        'Cliff not reached'
      )
    }
    disableHoverableContent
  >
    <Pill
      size="small"
      label="Cliff"
      icon={() => <Clock className="h-3 w-3" />}
    />
  </Tooltip>
)
